import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../i18n';
import * as S from './styled';

export { NoResults } from './styled';

const NavigationSearch = ({ searchTerm, onSearchChange, isMenuOpen, isSearching, matchCount, totalCount }) => {
  const inputRef = useRef(null);

  // Auto-focus input when menu opens; clear search when it closes
  useEffect(() => {
    if (isMenuOpen) {
      inputRef.current?.focus();
    } else {
      onSearchChange('');
    }
  }, [isMenuOpen, onSearchChange]);

  if (!isMenuOpen) return null;

  return (
    <S.NavSearchWrapper data-testid="nav-search-wrapper">
      <S.SearchBox>
        <S.SearchIcon />
        <S.SearchInputField
          ref={inputRef}
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Escape') {
              onSearchChange('');
              inputRef.current?.blur();
            }
          }}
          placeholder={t('common.nav_search_placeholder')}
          data-testid="nav-search-input"
          aria-label={t('common.nav_search_placeholder')}
          autoComplete="off"
          spellCheck="false"
        />
        {searchTerm && <S.ClearButton onClick={() => onSearchChange('')} aria-label={t('common.nav_search_clear')} />}
      </S.SearchBox>
      <S.MatchCount $visible={isSearching}>
        {t('common.nav_search_count', { match: matchCount, total: totalCount })}
      </S.MatchCount>
    </S.NavSearchWrapper>
  );
};

NavigationSearch.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool.isRequired,
  isSearching: PropTypes.bool.isRequired,
  matchCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired
};

export default NavigationSearch;
